import { HttpErrorResponse,HttpResponse } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { AppService } from '@core/services/app.service';
import { ErrorHandlerService } from '@core/services/errorHandler/error-handler.service';
import { SteuerdatenService } from '@core/services/steuerdaten.service';
import { StorageService } from '@core/services/storage.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgOption } from '@ng-select/ng-select';
import { TranslocoService } from '@ngneat/transloco';
import { sessionStorageKeys } from '@shared/constants/SessionStorageKeys';
import {
  ExtConstants,
  FlashFileExtension,
  FlashFileSpecialExtension,
} from '@shared/lists/flashFileExtension';
import { LogLevel } from '@shared/lists/logLevel';
import { specialSerie } from '@shared/lists/specialSerie';
import { ExpertToolCalculation } from '@shared/models/expertool-dynamic-models/ExpertToolCalculation';
import { VedocData } from '@shared/models/experttool/VedocData';
import { BdpName } from '@shared/models/filetype/BdpName';
import { BdpSerieFilter } from '@shared/models/filetype/BdpSerieFilter';
import { SeriesSteuerDaten } from '@shared/models/filetype/SeriesSteuerDaten';
import { map, Observable, Subscription } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { FcscBdpModalComponent } from '../fcsc-bdp-modal/fcsc-bdp-modal.component';
import { SeriesBdp, SeriesBdpHistoryFile } from '@shared/models/filetype/SeriesBdp';
import { FcscFinlogComponent } from '../fcsc-finlog/fcsc-finlog.component';
import { userSettingKeys } from '@shared/constants/UsertSettingKeys';
import { UserSettingService } from '@core/services/user-setting.service';
import { SharedSeriesService } from '@core/services/shared-series.service';
import { AdminService } from '@core/services/admin.service';
import { entitlements } from '@env/entitlements';
import { SecurityService } from '@core/services/security.service';
import { AsTaktSDBeuerDatenActivation } from '@shared/models/filetype/SeriesSteuerDatenActivation';
import { FcscSerienBdpComponent } from '@fcsc/fcsc-uploadtool/fcsc-serien-images/components/fcsc-serien-bdp/fcsc-serien-bdp.component';


@Component({
  standalone: false,
  selector: 'app-fcsc-flashware',
  templateUrl: './fcsc-flashware.component.html',
  styleUrls: ['./fcsc-flashware.component.scss'],
})
export class FcscFlashwareComponent implements OnInit, OnDestroy, OnChanges {
  @Input() vedocData!: VedocData;
  @Input() selectedSdpInput!: string;
  @Input() selectedBdpName!: string;
  @Input() finlog!: FcscFinlogComponent;
  @Input() ref!: any;
  @Output() selectSdpName = new EventEmitter<string>();
  @Output() selectBdpName = new EventEmitter<string>();
  @Output() selectFormattedBdpName = new EventEmitter<string>();
  @Output() selectedExtention = new EventEmitter<string>();
  @Output() selectedSumsCheck = new EventEmitter<boolean>();
  @Output() xentryReleaseList = new EventEmitter<any>();
  form!: UntypedFormGroup;
  selectedSdpName!: any;
  @Input() selectedBdpModalRow!: any;
  @Output() selectBdpModalRow = new EventEmitter<any>();
  seriesBdpHistoryFiles: SeriesBdpHistoryFile[] = [];
  formattedBdpName: string = '';
  formLoaded!: boolean;
  isChecked = true;
  isFlashFullVehicleChecked = false;
  isSums = false;
  sumsCheckVisible =false;
  isSectionCollapsed = true;
  subscription!: Subscription;
  collapesedCheck!: boolean;
  logLevelItems!: NgOption[];
  flashFileExtItems!: NgOption[];
  asTaktItems: NgOption[] = [];
  xentryReleasesItems: NgOption[] = [];
  bdpSerieFilter: BdpSerieFilter[] = [];
  selected: BdpSerieFilter[] = [];
  extractedSerie!: string;
  isSpecialSerie!: boolean;
  translatedPlaceholder!: string;
  @Input() fromReader!: boolean;
  isVedocDataEnabled: boolean;
  isVedocDataChecked: boolean;
  hasfcscLogs: boolean;
  hasFWCalcWOSUMSEntitlement: boolean = false;
  currentVersion: string= '';
  previousinseriesVersion: string= '';
  inseriesversion: string= '';
  validVersions!: string[];
  Timing: string= '';
  isValidasTakt!: boolean;
  issdpModalOpen = false;
  isbdpModalOpen = false;
  

  sumsOnEntitlement = [ entitlements.VUS.FCSC_SUMS_ON ];
  public flashwareCalculationEntitlement = [entitlements.VUS.FLASHWARE_CALCULATION];
  public sdpModificationEntitlement = [entitlements.VUS.FCSC_VORAB_DATA];
  public bdpModificationEntitlement = [entitlements.VUS.FCSC_MANAGEMENT_DATA];
  

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: UntypedFormBuilder,
    private modalService: NgbModal,
    private translocoService: TranslocoService,
    private storageService: StorageService,
    private steuerdatenService: SteuerdatenService,
    private notificationService: ErrorHandlerService,
    private appService: AppService,
    private userSettingService: UserSettingService,
    private sharedSeriesService : SharedSeriesService,
    public adminService: AdminService,
    private securityService: SecurityService
  ) {}

  async ngOnInit(): Promise<void> {
    const fcsc_logs = entitlements.VUS.FCSC_VORAB_DATA;
    this.hasfcscLogs = this.securityService.getEntitlements().some(() =>
      this.securityService.getEntitlements().includes(fcsc_logs)
    );

    const FWCalcWOSUMSEntitlement = entitlements.VUS.FLASHWARE_CALCULATION_WITHOUT_SUMS;
    this.hasFWCalcWOSUMSEntitlement = this.securityService.getEntitlements().some(() =>
      this.securityService.getEntitlements().includes(FWCalcWOSUMSEntitlement)
    );

    const SUMSOnEntitlement = entitlements.VUS.FCSC_SUMS_ON;
    this.storageService.saveData('hasSUMSOn', this.securityService.getEntitlements().some(() =>
      this.securityService.getEntitlements().includes(SUMSOnEntitlement)
    ));
    this.logLevelItems = LogLevel;
    this.extractedSerie =
      this.steuerdatenService.extractSerieFromFinVin(
        this.vedocData && this.vedocData.fin
      ) ||
      this.steuerdatenService.extractSerieFromFinVin(
        this.vedocData && this.vedocData.vin
      );

    const metadata = this.storageService
      .getData(sessionStorageKeys.calculationData)
      ?.payload?.finLog?.metadata?.[0]?.value;
    const timingObj = metadata?.find((item: any) => item.key === 'TIMING');
    this.Timing = timingObj?.value ?? '';

    this.isSpecialSerie = specialSerie.indexOf(this.extractedSerie) > -1;

    this.flashFileExtItems = this.isSpecialSerie
      ? JSON.parse(JSON.stringify(FlashFileSpecialExtension))
      : FlashFileExtension;
    this.setabfragenStatus();
  }

  checkUnselected() {
    return this.form.get('fileExt')?.value === this.translatedPlaceholder;
  }

  handleExtentionChange(event): void {
    this.selectedExtention.emit(event.name);
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.form && this.form.get('sdpName')) {
      this.form.get('sdpName')?.setValue(this.selectedSdpInput);
      this.form.get('bdpName')?.setValue(this.selectedBdpName);
      this.xentryReleasesItems = [];
      this.asTaktItems = [];
    }
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
  fetchAsTaktData(sdps: string[]): void {
    const isVorab = this.selectedBdpName?.startsWith(BdpName.VORAB);
    const defaultBdp = this.storageService.getData(sessionStorageKeys.defaultBDP);
    const isCustomCalculation = isVorab || (defaultBdp !== this.selectedBdpName);
    this.steuerdatenService.postAsTaktData(sdps, isCustomCalculation).subscribe({
      next: (resp: HttpResponse<any>) => {
      this.currentVersion = resp.body[0]?.currentVersion;
      this.inseriesversion = resp.body[0]?.inSeriesVersion ?? '';
      this.previousinseriesVersion = resp.body[0]?.previousInseriesVersion ?? '';
      this.validVersions  = resp.body[0]?.validVersions.FOR_EXP_TOOL;
      const AsTaktVersions = isCustomCalculation
        ? [...new Set([...this.validVersions, this.previousinseriesVersion, this.inseriesversion].filter(Boolean))]
        : [...new Set([...this.validVersions, this.currentVersion, this.previousinseriesVersion, this.inseriesversion].filter(Boolean))];
      const inseriesversionMark = isCustomCalculation ? this.inseriesversion : this.currentVersion;
      this.asTaktItems = AsTaktVersions.map(v => ({
        value: v,
        name: v === inseriesversionMark ? `${v} (in series)` : v
      }));
      this.sharedSeriesService.setValidAstakt(AsTaktVersions);
      this.sharedSeriesService.setimportedAstakt(this.Timing);
      this.sharedSeriesService.setValidversion(this.validVersions);
      this.sharedSeriesService.setimportedAstakt(this.Timing);
      this.form.get('astakt')?.valueChanges.subscribe((selectedItem) => {
        this.sharedSeriesService.setimportedAstakt(selectedItem);// Update the shared service
      });
      const initialAsTakt = this.Timing || (isCustomCalculation ? this.inseriesversion : this.currentVersion);
      this.form.patchValue({
        astakt: initialAsTakt
      });
      },
      error: (error: HttpErrorResponse) => {
      this.currentVersion = '';
      this.validVersions = [];
      this.asTaktItems = [];
      const errorAsTakt = this.Timing || (isCustomCalculation ? this.inseriesversion : this.currentVersion);
      this.form.patchValue({
        astakt: errorAsTakt
      });
      this.sharedSeriesService.setimportedAstakt(this.Timing);
      const AsTaktVersions = isCustomCalculation
        ? [...new Set([...this.validVersions, this.previousinseriesVersion, this.inseriesversion].filter(Boolean))]
        : [...new Set([...this.validVersions, this.currentVersion, this.previousinseriesVersion, this.inseriesversion].filter(Boolean))];
      this.sharedSeriesService.setValidAstakt(AsTaktVersions);
      this.sharedSeriesService.setimportedAstakt(this.Timing);
      this.sharedSeriesService.setValidversion(this.validVersions);
      }
    });
  }  
  isValidVersion(controlName: string): boolean {
    const isVorab = this.selectedBdpName?.startsWith(BdpName.VORAB);
    const defaultBdp = this.storageService.getData(sessionStorageKeys.defaultBDP);
    const isCustomCalculation = isVorab || (defaultBdp !== this.selectedBdpName);
    const AsTaktVersions = isCustomCalculation
      ? [...new Set([...(this.validVersions || []), this.previousinseriesVersion, this.inseriesversion].filter(Boolean))]
      : [...new Set([...(this.validVersions || []), this.currentVersion, this.previousinseriesVersion, this.inseriesversion].filter(Boolean))];
    const value = this.form.get(controlName)?.value;
    if (!value) {
      // Don't mark invalid if empty
      return true;
    }
    return !!value && (AsTaktVersions ?? []).includes(value);
  }  

  getXentryReleases(sdpName: string) {
    this.steuerdatenService.getRcddbLookupXentryReleases(sdpName).subscribe(
      (data: string[]) => {
        if (data) {
          data.sort((a, b) => a.localeCompare(b)).reverse();
          data.forEach((dt) => {
            this.xentryReleasesItems = [
              ...this.xentryReleasesItems,
              { name: dt, value: dt },
            ];
          });
          if (this.fromReader){
            this.emitXentryReleaseData(data)
          }
        }
      },
      (error: HttpErrorResponse) => {
        this.form?.patchValue({
          xentryReleases: '',
        });

        this.notificationService.handleServerErrorNotification(
          error,
          'modules.admin-section.config-modal.insert-edit-api-error-message'
        );
      }
    );
  }

  setabfragenStatus() {
    const vedocData = this.storageService.getData(sessionStorageKeys.vedocData);
    const detectedBaureihe = this.sharedSeriesService.getExtractedSerie(vedocData);
    this.adminService.getSeriesConfig().subscribe(
      (adminSeriesConfig: any) => {
        for (const baureihe of adminSeriesConfig) {
          if (baureihe.brName === detectedBaureihe) {
            if(this.storageService.getData(sessionStorageKeys.readType) == "loadFromFINNumber") {
              if(baureihe.vpMethod === "kVP") {
                this.isVedocDataEnabled = false;
                this.isVedocDataChecked = true;
              }
              else {
                this.isVedocDataEnabled = true;
                this.isVedocDataChecked = true;
              }
            }
            else if(this.storageService.getData(sessionStorageKeys.readType) == "loadFromFINLog") {
              if(baureihe.vpMethod === "kVP") {
                const calculationData = this.storageService.getData(sessionStorageKeys.calculationData);
                let vedocFound = false;
                calculationData.payload.finLog.metadata.forEach((data) => {
                  if(data.key === "VEDOC") {
                    vedocFound = true;
                    if(data.value.length) {
                      this.isVedocDataEnabled = true;
                      this.isVedocDataChecked = false;
                    }
                    else {
                      this.isVedocDataEnabled = false;
                      this.isVedocDataChecked = true;
                    }
                  }
                })
                if(vedocFound === false) {
                  this.isVedocDataEnabled = false;
                  this.isVedocDataChecked = true;
                }
              }
              else {
                this.isVedocDataEnabled = true;
                this.isVedocDataChecked = true;
              }
            }
          }
        }
        this.handleSpecialSerie();
        return undefined;
      });
  }

  private async createForm() {
    const flashForm =
      this.storageService.getData(sessionStorageKeys.flashForm) || {};
    if (flashForm.sdpName) {
      this.selectedSdpName = flashForm.sdpName;
      this.selectedBdpName = flashForm.bdpName;
      
      // When loading from uploaded file, just use the BDP name as-is
      if(this.storageService.getData(sessionStorageKeys.readType) == "loadFromFINLog" && flashForm.bdpName) {
        this.formattedBdpName = flashForm.bdpName;
      }
    } else if (flashForm.bdpName) {
      // Only BDP present (no SDP) in file
      this.selectedBdpName = flashForm.bdpName;
      if(this.storageService.getData(sessionStorageKeys.readType) == "loadFromFINLog") {
        this.formattedBdpName = flashForm.bdpName;
      }
    }
    if (this.selectedSdpInput) {
      this.selectedSdpName = this.selectedSdpInput;
      this.selectedBdpName = this.selectedBdpName;
    }
    this.form = this.formBuilder.group({
      logLevel: new UntypedFormControl({
        value:flashForm.logLevel || '2',
        disabled: !this.hasfcscLogs
      }),
      fileExt: new UntypedFormControl({
        value: this.isSpecialSerie
          ? this.translatedPlaceholder
          : flashForm.fileExt || ExtConstants.DEFAULT,
        disabled: !this.isSpecialSerie,
      }),
      sdpName: new UntypedFormControl(
        this.selectedSdpInput || flashForm.sdpName || ''
      ),
      bdpName: new UntypedFormControl(this.selectedBdpName || flashForm.bdpName || ''),
      xentryReleases: new UntypedFormControl(
        flashForm.xentryReleases || '2100.10.000'
      ),
      astakt: new UntypedFormControl(flashForm.astakt || ''),
      abfragen: new UntypedFormControl(
        this.isVedocDataChecked
      ),
      flashFullVehicle: new UntypedFormControl(
        flashForm.hasOwnProperty('flashFullVehicle') ? flashForm.flashFullVehicle : false
      ),
      aktivieren: new UntypedFormControl(
        flashForm.hasOwnProperty('aktivieren') ? flashForm.aktivieren : false
      ),
      sumsAktivieren: new UntypedFormControl({
        value: flashForm.hasOwnProperty('sumsAktivieren') ? flashForm.sumsAktivieren : false,
        disabled: !this.hasFWCalcWOSUMSEntitlement
      }),
    });
    this.storageService.saveData('isSUMSOnChecked', false);
    if(!this.hasfcscLogs) {
      this.form.get('logLevel')?.setValue("0");
    }
    else {
      (await this.userSettingService.fetchUserSetting(
        userSettingKeys.experttool.expToolLogLevel
      ).then(
        (response: any) => {
          if (Object.keys(response).length === 0 && response.constructor === Object) {
            this.form.get('logLevel')?.setValue("0");
          } else {
            this.form.get('logLevel')?.setValue(response);
          }
        }
      )
      )
    }
    this.storageService.saveData(sessionStorageKeys.flashForm, this.form.value);
    this.subscription = this.form.valueChanges.subscribe((formValues) => {
      const disabledFieldValue = this.form.get('logLevel')?.value;
      const updatedValues = {
        ...formValues,
        logLevel: disabledFieldValue
      };

      this.storageService.saveData(sessionStorageKeys.flashForm, updatedValues);
    });
    if(this.storageService.getData(sessionStorageKeys.readType)=="loadFromFINNumber"){
    this.getDefaultBdpBySerie();
    } else if (this.storageService.getData(sessionStorageKeys.readType) === "loadFromFINLog") {
      this.validateAndSetBdpSdpFromFile();
    }
    this.formLoaded = true;
  }

  onSelectionChange(event: any) {
    this.userSettingService.saveUserSetting(
      userSettingKeys.experttool.expToolLogLevel,
      event.name
    );
}

  openModal() {
    const modalRef = this.modalService.open(FcscBdpModalComponent, {
      size: 'lg',
      windowClass: 'details-modal override',
      backdrop: 'static',
      keyboard: false,
    });
    this.issdpModalOpen = false;
    this.isbdpModalOpen = true;
    modalRef.componentInstance.selectedFin =
      this.vedocData.fin || this.vedocData.vin;
    modalRef.componentInstance.title = this.translocoService.translate(
      'modules.expert-tool.modal-bdp-title'
    );
    modalRef.componentInstance.subText = this.translocoService.translate(
      'modules.expert-tool.modal-bdp-sub-title'
    );
    modalRef.componentInstance.ref = this;
    modalRef.componentInstance.finlog = this.finlog;
    modalRef.componentInstance.selectedSdpName = this.selectedSdpName;
    modalRef.result.then((result) => {
      this.activate(result);
    });
  }

  openBDPModal(){
    const modalRef = this.modalService.open(FcscSerienBdpComponent, {
      size: 'lg',
      windowClass: 'details-modal override',
      backdrop: 'static',
      keyboard: false,
    });
    this.issdpModalOpen = true;
    this.isbdpModalOpen = false;
    modalRef.componentInstance.ref = this;
    modalRef.componentInstance.selectedFin =
      this.vedocData.fin || this.vedocData.vin;
    modalRef.componentInstance.isFromExpertTool = true;
    modalRef.componentInstance.finlog = this.finlog;
    modalRef.componentInstance.selectedSdpName = this.selectedSdpName;
    modalRef.result.then((result) => {
      this.activate(result);
    });
  }

  handleActivation(result): void {
    this.activate(result);
  }

  activate(result) {
    if (result && result.length) {
      this.selectedSdpName = result[0].sdpName ?? result[0].name;
      this.selectedBdpName = result[0].bdpName;
      this.selectedBdpModalRow = result[0];
      this.formattedBdpName = this.formatBDPName();
      this.performActivation();
    } else if (result && result.bdpName) {
      this.selectedBdpName = result.bdpName;
      this.selectedBdpModalRow = result;
      this.formattedBdpName = this.formatBDPName();
      const vedocData = this.storageService.getData(sessionStorageKeys.vedocData);
      const detectedBaureihe = this.sharedSeriesService.getExtractedSerie(vedocData);
      this.steuerdatenService
        .getBdpHistoryFiles(this.selectedBdpName)
        .subscribe((data: SeriesBdpHistoryFile[]) => {
          this.seriesBdpHistoryFiles = data;
          const sdpname = this.seriesBdpHistoryFiles.find(item =>
            item.name.includes(`${detectedBaureihe}`)
          );
          this.selectedSdpName = sdpname ? sdpname.name : '';
          this.performActivation();
        });
    }
  }

  private performActivation() {
    this.getXentryReleases(this.selectedSdpName);
    if (this.xentryReleasesItems) {
      this.form?.patchValue({
        xentryReleases: '2100.10.000',
      });
    }
    this.fetchAsTaktData([this.selectedSdpName]);
    this.storageService.saveData(
      sessionStorageKeys.flashForm,
      this.form.value
    );
    this.storageService.saveData(
      sessionStorageKeys.selectedBdpName,
      this.selectedBdpName
    );
    this.storageService.saveData(
      sessionStorageKeys.formattedBdpName,
      this.formattedBdpName
    );
    this.selectBdpName.emit(this.selectedBdpName);
    this.selectFormattedBdpName.emit(this.formattedBdpName);
    this.selectSdpName.emit(this.selectedSdpName);
    if (this.selectedBdpModalRow) {
      this.storageService.saveData(
        sessionStorageKeys.selectedBdpModalRow,
        this.selectedBdpModalRow
      );
      this.selectBdpModalRow.emit(this.selectedBdpModalRow);
    }
    this.form.get('sdpName')?.setValue(this.selectedSdpName);
    this.form.get('bdpName')?.setValue(this.selectedBdpName);
  }

  formatBDPName(){
        const formatted = this.steuerdatenService.formatBDPName(this.selectedBdpModalRow);
        return formatted || this.selectedBdpName || '';
    }


  handleCheck(event): void {
    if(this.isVedocDataEnabled) {
      const checkControl = this.form.get('abfragen');

      checkControl?.setValue(!checkControl.value);
      this.isChecked = !this.isChecked;
    }
    else {
      event.preventDefault();
      return;
    }
  }

  handleFlashFullVehicleCheck(): void{
    const checkControl = this.form.get('flashFullVehicle');

    checkControl?.setValue(!checkControl.value);
    this.isFlashFullVehicleChecked = !this.isFlashFullVehicleChecked
  }

  handleSumsCheck(): void {
    const check = this.form.get('aktivieren');

    check?.setValue(!check.value);
    this.isSums = !this.isSums;
    this.selectedSumsCheck.emit(this.isSums);
  }

  handleSumsOnCheck(): void {
    if(this.hasFWCalcWOSUMSEntitlement) {
      const check = this.form.get('sumsAktivieren');
      const value = !check?.value;
      check?.setValue(value);
      this.storageService.saveData('isSUMSOnChecked', value);
    }
  }




  private validateAndSetBdpSdpFromFile(): void {
    const fileSdpName = this.selectedSdpName;
    const fileBdpName = this.selectedBdpName;

    if (!fileSdpName && !fileBdpName) {
      this.getDefaultBdpBySerie();
      return;
    }

    const extractedSerie = this.getExtractedSerie();

    if (fileSdpName) {
      // SDP is present → find matching VORAB BDP by SDP name and activate
      this.steuerdatenService.getBdpBySerie(extractedSerie).subscribe(
        (bdpEntries) => {
          // Find and store the series default BDP
          const seriesDefault = bdpEntries.find(entry =>
            entry.bdpName.startsWith(BdpName.SERIEN)
          );
          if (seriesDefault) {
            this.storageService.saveData(sessionStorageKeys.defaultBDP, seriesDefault.bdpName);
          }

          const matchingEntry = bdpEntries.find(
            entry => entry.sdpName === fileSdpName && entry.bdpName.startsWith(BdpName.VORAB)
          );

          if (matchingEntry) {
            this.applyCustomBdp(matchingEntry, fileSdpName, fileBdpName);
          } else {
            this.getDefaultBdpBySerie();
          }
        },
        (error: HttpErrorResponse) => {
          this.getDefaultBdpBySerie();
        }
      );
    } else {
      // Only BDP present (no SDP)
      if (fileBdpName.startsWith(BdpName.VORAB)) {
        // Already a prefixed VORAB name → fetch SDP from BDAP for this carline, then activate
        this.steuerdatenService.getBdpBySerie(extractedSerie).subscribe(
          (bdpEntries) => {
            const seriesDefault = bdpEntries.find(entry =>
              entry.bdpName.startsWith(BdpName.SERIEN)
            );
            if (seriesDefault) {
              this.storageService.saveData(sessionStorageKeys.defaultBDP, seriesDefault.bdpName);
            }

            const matchingEntry = bdpEntries.find(e => e.bdpName === fileBdpName);
            if (matchingEntry) {
              this.applyCustomBdp(matchingEntry, matchingEntry.sdpName, this.formattedBdpName || fileBdpName);
            } else {
              // BDP not found in serie entries → try fetching SDP from history files
              this.fetchSdpFromBdpHistory(fileBdpName);
            }
          },
          () => {
            // API error → try fetching SDP from history files as fallback
            this.fetchSdpFromBdpHistory(fileBdpName);
          }
        );
      } else {
        // Formatted name (e.g. 260505_044327_VP7.0.2) → resolve prefixed name via API
        this.steuerdatenService.getBdpByFormattedName(fileBdpName).subscribe(
          (bdpHistory) => {
            console.log('BDP history for formatted name:', bdpHistory);
            if (bdpHistory && bdpHistory.length > 0) {
              const prefixedBdpName = bdpHistory[0].bdpName;
              this.steuerdatenService.getBdpBySerie(extractedSerie).subscribe(
                (bdpEntries) => {
                  const seriesDefault = bdpEntries.find(entry =>
                    entry.bdpName.startsWith(BdpName.SERIEN)
                  );
                  if (seriesDefault) {
                    this.storageService.saveData(sessionStorageKeys.defaultBDP, seriesDefault.bdpName);
                  }

                  const entryFromList = bdpEntries.find(e => e.bdpName === prefixedBdpName);
                  if (entryFromList) {
                    this.applyCustomBdp(entryFromList, entryFromList.sdpName, fileBdpName);
                  } else {
                    this.applyCustomBdpDirect(prefixedBdpName, '', fileBdpName, bdpHistory[0]);
                  }
                },
                () => {
                  this.applyCustomBdpDirect(prefixedBdpName, '', fileBdpName, bdpHistory[0]);
                }
              );
            } else {
              this.getDefaultBdpBySerie();
            }
          },
          () => {
            this.getDefaultBdpBySerie();
          }
        );
      }
    }
  }

  private applyCustomBdp(entry: BdpSerieFilter, sdpName: string, formattedBdp: string): void {
    this.selectedBdpName = entry.bdpName;
    this.selectedSdpName = sdpName || entry.sdpName;
    this.selectedBdpModalRow = entry;
    this.formattedBdpName = formattedBdp || this.formatBDPName();

    this.selectSdpName.emit(this.selectedSdpName);
    this.selectBdpName.emit(this.selectedBdpName);
    this.selectFormattedBdpName.emit(this.formattedBdpName);
    this.storageService.saveData(sessionStorageKeys.selectedBdpName, this.selectedBdpName);
    this.storageService.saveData(sessionStorageKeys.formattedBdpName, this.formattedBdpName);
    this.storageService.saveData(sessionStorageKeys.selectedBdpModalRow, this.selectedBdpModalRow);

    this.form?.patchValue({
      sdpName: this.selectedSdpName,
      bdpName: this.selectedBdpName,
    });

    this.getXentryReleases(this.selectedSdpName);
    this.fetchAsTaktData([this.selectedSdpName]);
    this.checkAndActivateBdp(entry.bdpName);
  }

  private applyCustomBdpDirect(prefixedBdpName: string, sdpName: string, formattedBdp: string, bdpData: any): void {
    this.selectedBdpName = prefixedBdpName;
    this.selectedBdpModalRow = bdpData;
    this.formattedBdpName = formattedBdp || this.formatBDPName();

    if (sdpName) {
      this.selectedSdpName = sdpName;
      this.finishApplyCustomBdpDirect(prefixedBdpName);
    } else {
      // No SDP provided → fetch it from BDAP history files for this carline
      const vedocData = this.storageService.getData(sessionStorageKeys.vedocData);
      const detectedBaureihe = this.sharedSeriesService.getExtractedSerie(vedocData);
      this.steuerdatenService
        .getBdpHistoryFiles(prefixedBdpName)
        .subscribe(
          (data: SeriesBdpHistoryFile[]) => {
            const sdpFile = data.find(item => item.name.includes(`${detectedBaureihe}`));
            this.selectedSdpName = sdpFile ? sdpFile.name : '';
            this.finishApplyCustomBdpDirect(prefixedBdpName);
          },
          () => {
            this.selectedSdpName = '';
            this.finishApplyCustomBdpDirect(prefixedBdpName);
          }
        );
    }
  }

  private finishApplyCustomBdpDirect(prefixedBdpName: string): void {
    this.selectSdpName.emit(this.selectedSdpName);
    this.selectBdpName.emit(this.selectedBdpName);
    this.selectFormattedBdpName.emit(this.formattedBdpName);
    this.storageService.saveData(sessionStorageKeys.selectedBdpName, this.selectedBdpName);
    this.storageService.saveData(sessionStorageKeys.formattedBdpName, this.formattedBdpName);
    this.storageService.saveData(sessionStorageKeys.selectedBdpModalRow, this.selectedBdpModalRow);

    this.form?.patchValue({
      sdpName: this.selectedSdpName,
      bdpName: this.selectedBdpName,
    });

    if (this.selectedSdpName) {
      this.getXentryReleases(this.selectedSdpName);
      this.fetchAsTaktData([this.selectedSdpName]);
    }
    this.checkAndActivateBdp(prefixedBdpName);
  }

  private fetchSdpFromBdpHistory(bdpName: string): void {
    const vedocData = this.storageService.getData(sessionStorageKeys.vedocData);
    const detectedBaureihe = this.sharedSeriesService.getExtractedSerie(vedocData);
    this.selectedBdpName = bdpName;
    this.steuerdatenService
      .getBdpHistoryFiles(bdpName)
      .subscribe(
        (data: SeriesBdpHistoryFile[]) => {
          this.seriesBdpHistoryFiles = data;
          const sdpFile = data.find(item => item.name.includes(`${detectedBaureihe}`));
          this.selectedSdpName = sdpFile ? sdpFile.name : '';
          this.performActivation();
        },
        () => {
          this.selectedSdpName = '';
          this.selectBdpName.emit(this.selectedBdpName);
          this.storageService.saveData(sessionStorageKeys.selectedBdpName, this.selectedBdpName);
          this.form?.patchValue({ bdpName: this.selectedBdpName });
          this.checkAndActivateBdp(bdpName);
        }
      );
  }

  private checkAndActivateBdp(bdpName: string): void {
    this.steuerdatenService.getBdpVorabActivationStatus(bdpName).subscribe(
      (status) => {
        if (status.status !== 'ACTIVE') {
          // Not active → activate it
          this.steuerdatenService.putBdpVorabActivationStatus(bdpName).subscribe(
            () => {
              // Start polling for activation status
              this.finlog.startLoaderbdp(bdpName);
            },
            (error: HttpErrorResponse) => {
              this.notificationService.handleServerErrorNotification(
                error,
                'modules.expert-tool.modal-bdp-activation-error'
              );
            }
          );
        }
      },
      (error: HttpErrorResponse) => {
        this.notificationService.handleServerErrorNotification(
          error,
          'modules.expert-tool.modal-bdp-activation-error'
        );
      }
    );
  }

  private getDefaultBdpBySerie(): void {
    this.steuerdatenService.getBdpBySerie(this.getExtractedSerie()).subscribe(
      (data: BdpSerieFilter[]) => {
        if (data) {
          this.bdpSerieFilter = data;
          const sorted = this.sortBySmokeTestStatus();
          const serieIndex = sorted.findIndex((st) =>
            st.bdpName.startsWith(BdpName.SERIEN)
          );
          const autoSelected = [sorted[serieIndex]];
          this.selected = [...autoSelected];

          this.selectedSdpName = this.selected[0] && this.selected[0].sdpName
          this.selectSdpName.emit(this.selectedSdpName);
          this.selectedBdpName = this.selected[0] && this.selected[0].bdpName;
          this.selectBdpName.emit(this.selectedBdpName);
          this.storageService.saveData(sessionStorageKeys.defaultBDP,this.selectedBdpName);
          // Fetch the full BDP data to get setInSerieAt and vpVersion for formatting
          if (this.selectedBdpName) {
            this.steuerdatenService.getSeriesProductiveBdp().subscribe(
              (bdpData: any[]) => {
                if (bdpData && bdpData.length > 0) {
                  this.selectedBdpModalRow = bdpData[0];
                  console.log("bdpData",bdpData)
                  this.formattedBdpName = this.formatBDPName();
                  this.storageService.saveData(
                    sessionStorageKeys.formattedBdpName,
                    this.formattedBdpName
                  );
                  this.selectFormattedBdpName.emit(this.formattedBdpName);
                }
              },
              (error) => {
                // If we can't get the formatted data, just show the BDP name
                this.formattedBdpName = this.selectedBdpName;
                this.storageService.saveData(
                  sessionStorageKeys.formattedBdpName,
                  this.formattedBdpName
                );
                this.selectFormattedBdpName.emit(this.formattedBdpName);
              }
            );
          }
          
          this.getXentryReleases(this.selectedSdpName);
          this.fetchAsTaktData([this.selectedSdpName]);
        }
      },
      (error: HttpErrorResponse) => {
        this.selectedSdpName = '';
        this.selectedBdpName = '';
        this.selectSdpName.emit(this.selectedSdpName);
        this.selectBdpName.emit(this.selectedBdpName);
        this.notificationService.handleServerErrorNotification(
          error,
          'global.bdp-status.service-down'
        );
      }
    );
  }

  private getExtractedSerie(): string {
    const filteredSerie = `C${
      this.steuerdatenService.extractSerieFromFinVin(
        this.vedocData && this.vedocData.fin
      ) ||
      this.steuerdatenService.extractSerieFromFinVin(
        this.vedocData && this.vedocData.vin
      )
    }`;
    return filteredSerie;
  }

  private sortBySmokeTestStatus(): BdpSerieFilter[] {
    return this.bdpSerieFilter.sort((a, b) =>
      a.smokeTestStatus < b.smokeTestStatus
        ? 1
        : b.smokeTestStatus < a.smokeTestStatus
        ? -1
        : 0
    );
  }

  private handleSpecialSerie() {
    if (this.isSpecialSerie) {
      this.appService
        .translateKey('modules.data-management.select-option')
        .subscribe((translation) => {
          this.flashFileExtItems = JSON.parse(
            JSON.stringify(FlashFileSpecialExtension)
          );
          this.flashFileExtItems.unshift({ name: translation });
          this.translatedPlaceholder = translation;
          this.selectedExtention.emit(translation);
          this.createForm();
        });
    } else {
      this.selectedExtention.emit('');
      this.createForm();
    }
  }

  emitXentryReleaseData(data : string[]){
    this.xentryReleaseList.emit(data)
  }
}
